import CollectionContainer from '../containers/Collection';

class CollectionTemplate extends CollectionContainer {
  constructor() {
    super();
    super.init();
  }

  init() {
    console.log('UNTUCKit : Template : CollectionTemplate', this);
  }
}

$(() => {
  new CollectionTemplate();
});
